import { render, staticRenderFns } from "./income-payment-export.vue?vue&type=template&id=1d5364fa"
import script from "./income-payment-export.vue?vue&type=script&lang=js"
export * from "./income-payment-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports